import { Grid, Image, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  img123Final2,
  img3AlPaso,
  imgBarCodeFinal2,
  imgEtiquetaRollo1,
  imgFiguras1,
  imgImagesFinal,
  imgLogoNoText128,
  imgPlanilla1,
  imgPrinter1,
  imgQrCodeNuevo,
  imgTxtPng,
  imgVariableDataFinal2,
} from "../shared/images";
import { NavBarContainer } from "./NavBarContainer";

const TUTORIALS = [
  { id: "tutorial1", key: "howToRoll", img: imgEtiquetaRollo1, yt: "w6QBhV_9e7Y" },
  { id: "tutorial2", key: "howToSheet", img: imgPlanilla1, yt: "sH4YqscfRUY" },
  { id: "tutorial3", key: "howTo3Across", img: img3AlPaso, yt: "E30J1z7au6U" },
  { id: "tutorial4", key: "howToText", img: imgTxtPng, yt: "4UFN-fR9_Ao" },
  { id: "tutorial5", key: "howToShapes", img: imgFiguras1, yt: "qRKJKZA1L_4" },
  { id: "tutorial6", key: "howToImages", img: imgImagesFinal, yt: "_u8rg4jWM7k" },
  { id: "tutorial7", key: "howToBarCodes", img: imgBarCodeFinal2, yt: "OVxsjZYXnYo" },
  { id: "tutorial8", key: "howToQR", img: imgQrCodeNuevo, yt: "W76gN1Ojmf4" },
  { id: "tutorial9", key: "howToPrint", img: imgPrinter1, yt: "Zq6Vum7V7xk" },
  { id: "tutorial10", key: "howToConsecutive", img: img123Final2, yt: "_-envn_bF9c" },
  { id: "tutorial11", key: "howToDataBase", img: imgVariableDataFinal2, yt: "UbAv2qGqNYM" },
  { id: "tutorial12", key: "howToBuy", img: imgLogoNoText128, yt: "Wj-FSfzyWyE" },
] as const;

export function TutorialsPage() {
  const { t } = useTranslation();

  return (
    <NavBarContainer variant="marketing" title={t("fullTutorials.title")}>
      <Stack gap="lg">

        {TUTORIALS.map((tut) => (
          <Stack key={tut.id} id={tut.id} gap="sm">
            <Title order={4}>
              {t(`fullTutorials.${tut.key}` as "fullTutorials.title")}
            </Title>
            <Grid align="center">
              <Grid.Col span={{ base: 12, md: 4 }}>
                <Image src={tut.img} alt="" maw={200} />
              </Grid.Col>
              <Grid.Col span={{ base: 12, md: 8 }}>
                <iframe
                  width="100%"
                  height="300"
                  src={`https://www.youtube.com/embed/${tut.yt}`}
                  title={t(`fullTutorials.${tut.key}` as "fullTutorials.title")}
                  allowFullScreen
                  style={{ border: 0, maxWidth: 600 }}
                />
              </Grid.Col>
            </Grid>
          </Stack>
        ))}

        <Text size="sm" c="dimmed">
          {t("fullTutorials.alsoDistributor")}
        </Text>
      </Stack>
    </NavBarContainer>
  );
}
